<div class="flex flex-col gap-3">
  <div class="flex items-center justify-between gap-3">
    <p class="text-sm font-medium text-slate-800 m-0">Productos</p>
    <p-button label="Agregar producto" icon="pi pi-plus" size="small" type="button"
      [disabled]="lines().disabled || lines().length >= maxLines" (onClick)="openAdd()" />
  </div>

  <div class="rounded-lg border overflow-x-auto" [class.border-slate-200]="!showError()" [class.border-red-300]="showError()">
    <table class="w-full text-sm">
      <thead class="bg-slate-50 border-b border-slate-200">
        <tr class="text-xs text-slate-600">
          <th class="px-3 py-2 text-left font-semibold">Producto</th>
          <th class="px-3 py-2 text-right font-semibold">Cantidad</th>
          <th class="px-3 py-2 text-right font-semibold whitespace-nowrap">P. unitario <span class="font-normal">(sin imp.)</span></th>
          <th class="px-3 py-2 text-right font-semibold hidden sm:table-cell">Subtotal</th>
          <th class="px-3 py-2 text-right font-semibold hidden sm:table-cell">Impuestos</th>
          <th class="px-3 py-2 text-right font-semibold">Total</th>
          <th class="px-3 py-2"></th>
        </tr>
      </thead>
      <tbody class="divide-y divide-slate-100">
        @for (line of lines().controls; track line; let i = $index) {
          <tr class="hover:bg-slate-50">
            <td class="px-3 py-2 text-slate-900 max-w-[14rem] truncate">{{ description(line) }}</td>
            <td class="px-3 py-2 text-right text-slate-700">{{ line.get('quantity')?.value }}</td>
            <td class="px-3 py-2 text-right text-slate-700 whitespace-nowrap">{{ line.get('unitPrice')?.value | currency:'MXN':'symbol-narrow' }}</td>
            @if (lineAmounts(line); as amounts) {
              <td class="px-3 py-2 text-right text-slate-700 whitespace-nowrap hidden sm:table-cell">{{ amounts.subtotal | currency:'MXN':'symbol-narrow' }}</td>
              <td class="px-3 py-2 text-right text-slate-700 whitespace-nowrap hidden sm:table-cell">{{ amounts.tax | currency:'MXN':'symbol-narrow' }}</td>
              <td class="px-3 py-2 text-right font-medium text-slate-900 whitespace-nowrap">{{ amounts.total | currency:'MXN':'symbol-narrow' }}</td>
            } @else {
              <td class="px-3 py-2 text-right text-slate-400 hidden sm:table-cell">—</td>
              <td class="px-3 py-2 text-right text-slate-400 hidden sm:table-cell">—</td>
              <td class="px-3 py-2 text-right text-slate-400">—</td>
            }
            <td class="px-2 py-1 text-right whitespace-nowrap">
              <p-button icon="pi pi-pen-to-square" [rounded]="true" [text]="true" severity="secondary" type="button" ariaLabel="Editar producto"
                [disabled]="lines().disabled" (onClick)="openEdit(i)" />
              <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" type="button" ariaLabel="Quitar producto"
                [disabled]="lines().disabled" (onClick)="remove(i)" />
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="7" class="px-3 py-5 text-center text-sm" [class.text-slate-500]="!showError()" [class.text-red-600]="showError()">
              Agrega al menos un producto con «Agregar producto».
            </td>
          </tr>
        }
      </tbody>
      @if (totals(); as t) {
        <tfoot class="border-t border-slate-200 bg-slate-50/60 text-sm">
          <tr>
            <td colspan="3" class="px-3 py-2 text-right text-slate-600 hidden sm:table-cell">Totales</td>
            <td class="px-3 py-2 text-right text-slate-700 whitespace-nowrap hidden sm:table-cell">{{ t.subtotal | currency:'MXN':'symbol-narrow' }}</td>
            <td class="px-3 py-2 text-right text-slate-700 whitespace-nowrap hidden sm:table-cell">{{ t.tax | currency:'MXN':'symbol-narrow' }}</td>
            <td colspan="3" class="px-3 py-2 text-right text-slate-600 sm:hidden">Total</td>
            <td class="px-3 py-2 text-right font-semibold text-slate-900 whitespace-nowrap">{{ t.total | currency:'MXN':'symbol-narrow' }}</td>
            <td></td>
          </tr>
        </tfoot>
      }
    </table>
  </div>
  @if (totals()) {
    <p class="text-xs text-slate-500 m-0">El total con impuestos es lo que se cobra a la tarjeta y lo que dirá la factura.</p>
  }
</div>

<p-dialog
  [header]="editingIndex() == null ? 'Agregar producto' : 'Editar producto'"
  [visible]="dialogVisible()"
  (visibleChange)="!$event && closeDialog()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: 'min(36rem, calc(100vw - 2rem))' }">
  <form [formGroup]="lineForm" (ngSubmit)="saveLine()" class="flex flex-col gap-4 pt-1">
    <div class="flex flex-col gap-1">
      <p-floatlabel class="w-full" variant="on">
        <p-autocomplete
          [inputId]="idPrefix() + '-product'"
          formControlName="product"
          [suggestions]="productOptions()"
          (completeMethod)="onProductSearch($event)"
          (onSelect)="onProductSelect($event.value)"
          optionLabel="name"
          [minLength]="3"
          [showClear]="true"
          [invalid]="invalid('product')"
          fluid
          appendTo="body" />
        <label [for]="idPrefix() + '-product'">Producto *</label>
      </p-floatlabel>
      @if (invalid('product')) {
        <small class="text-red-600">Elige un producto del catálogo.</small>
      } @else {
        <small class="text-slate-500">Los impuestos se toman del producto.</small>
      }
    </div>

    <div class="flex flex-col gap-1">
      <p-floatlabel class="w-full" variant="on">
        <input pInputText [id]="idPrefix() + '-desc'" formControlName="description" maxlength="250" class="w-full" />
        <label [for]="idPrefix() + '-desc'">Descripción</label>
      </p-floatlabel>
      <small class="text-slate-500">Si la dejas vacía se usa el nombre del producto.</small>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div class="flex flex-col gap-1">
        <p-floatlabel class="w-full" variant="on">
          <p-inputNumber [inputId]="idPrefix() + '-qty'" formControlName="quantity" [minFractionDigits]="0" [maxFractionDigits]="2"
            [min]="0" inputStyleClass="text-right" [invalid]="invalid('quantity')" fluid />
          <label [for]="idPrefix() + '-qty'">Cantidad *</label>
        </p-floatlabel>
        @if (invalid('quantity')) {
          <small class="text-red-600">La cantidad debe ser mayor a 0.</small>
        }
      </div>
      <div class="flex flex-col gap-1">
        <p-floatlabel class="w-full" variant="on">
          <p-inputNumber [inputId]="idPrefix() + '-price'" formControlName="unitPrice" mode="currency" currency="MXN" locale="es-MX"
            inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" [invalid]="invalid('unitPrice')" fluid />
          <label [for]="idPrefix() + '-price'">Precio unitario *</label>
        </p-floatlabel>
        @if (invalid('unitPrice')) {
          <small class="text-red-600">Indica un precio mayor a 0.</small>
        } @else if (catalogPriceIncludesTaxes()) {
          <small class="text-slate-500">
            Precio de catálogo {{ dialogProduct()?.unitPrice | currency:'MXN':'symbol-narrow' }} con impuestos incluidos.
          </small>
        }
      </div>
      <div class="flex flex-col gap-1">
        <p-floatlabel class="w-full" variant="on">
          <p-inputNumber [inputId]="idPrefix() + '-subtotal'" [ngModel]="dialogSubtotal()" [ngModelOptions]="{ standalone: true }"
            mode="currency" currency="MXN" locale="es-MX" inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2"
            [readonly]="true" [disabled]="true" fluid />
          <label [for]="idPrefix() + '-subtotal'">Subtotal</label>
        </p-floatlabel>
        <small class="text-slate-500">Cantidad × precio unitario.</small>
      </div>
    </div>

    <div class="rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 text-sm">
      @if (dialogAmounts(); as amounts) {
        <dl class="m-0 flex flex-col gap-1">
          <div class="flex justify-between">
            <dt class="text-slate-600">Subtotal</dt>
            <dd class="m-0 text-slate-900">{{ amounts.subtotal | currency:'MXN':'symbol-narrow' }}</dd>
          </div>
          @for (tax of dialogTaxes(); track $index) {
            <div class="flex justify-between">
              <dt class="text-slate-600">{{ tax.label }}</dt>
              <dd class="m-0 text-slate-900">{{ tax.amount | currency:'MXN':'symbol-narrow' }}</dd>
            </div>
          } @empty {
            <div class="flex justify-between">
              <dt class="text-slate-600">Impuestos</dt>
              <dd class="m-0 text-slate-500">Sin impuestos</dd>
            </div>
          }
          <div class="flex justify-between border-t border-slate-200 pt-1 mt-1">
            <dt class="font-medium text-slate-800">Total de la línea</dt>
            <dd class="m-0 font-semibold text-slate-900">{{ amounts.total | currency:'MXN':'symbol-narrow' }}</dd>
          </div>
        </dl>
      } @else {
        <p class="m-0 text-slate-500">Elige un producto e indica cantidad y precio para ver impuestos y total.</p>
      }
    </div>
  </form>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cancelar" severity="secondary" [text]="true" type="button" (onClick)="closeDialog()" />
      <p-button [label]="editingIndex() == null ? 'Agregar' : 'Actualizar'" icon="pi pi-check" type="button" (onClick)="saveLine()" />
    </div>
  </ng-template>
</p-dialog>
